import * as React from "react"
import * as DialogPrimitive from "@radix-ui/react-dialog"
import { cn } from "@/lib/utils"

interface LoadingDialogProps {
  open: boolean
  onOpenChange?: (open: boolean) => void
  title?: string
  description?: string
}

// Custom DialogContent without close button
const DialogContentWithoutClose = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        className
      )}
      {...props}
    >
      {children}
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
))
DialogContentWithoutClose.displayName = "DialogContentWithoutClose"

export function LoadingDialog({
  open,
  onOpenChange = () => {},
  title = "Processing",
  description = "Please wait while we process your request..."
}: LoadingDialogProps) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={() => {}} modal>
      <DialogContentWithoutClose className="sm:max-w-[425px]">
        <DialogPrimitive.Title className="sr-only">
          {title}
        </DialogPrimitive.Title>
        <div className="flex flex-col items-center justify-center p-4 space-y-4">
          <div className="w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
          <div className="text-lg font-semibold">{title}</div>
          <div className="text-sm text-gray-500">{description}</div>
        </div>
      </DialogContentWithoutClose>
    </DialogPrimitive.Root>
  )
}
